// extracted by css-extract-rspack-plugin
export default {"tokenName":"_SWOCudMw5gLFv9c"};